import React, { useEffect, useState } from 'react'
import { UrlApi } from '../../services/apirest';
import moment from "moment"
import { Avatar, Button, Card, CardHeader, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateIcon from '@mui/icons-material/Create';
import Viajes from './Viajes';

export default function Viajesmostrar() {
  const [veresto, setVerEsto] = useState(true)
  const [viajes, setViajes] = useState([])
  const [totalkm, setTotalkm] = useState(0)
  const [data, setData] = useState([])
  const [openDialog, setOpendialog] = useState(false)
  const [editviaje, setEditViaje] = useState(false)
  const [refrescar, setRefrescar] = useState(false)
  const [periodo, setPeriodo] = useState([])

  useEffect(() => {
    obtenerPeriodo()

  }, [])

  useEffect(() => {
    obtenerViajes()
  }, [refrescar, veresto, periodo])


  useEffect(() => {
    setTotalkm(viajes.reduce((total, viaje) => total = total + (viaje.kmsfinal * 1 - viaje.kmsinicio * 1), 0))
  }, [viajes])

  const obtenerPeriodo = async () => {
    const datap = await fetch(UrlApi + "/viajest1/periodo/actual")
    const dataperiodos = await datap.json()
    setPeriodo(dataperiodos)
  }

  const obtenerViajes = async () => {
    console.log("somos el perido", periodo)
    const fdesde = moment(periodo[0].desde).format("YYYY-MM-DD")
    const fhasta = moment(periodo[0].hasta).format("YYYY-MM-DD")
    const data = await fetch(UrlApi + "/viajest1/chofer/" + localStorage.getItem("user") + "/" + fdesde + "/" + fhasta)
    const viajesData = await data.json()
    setViajes(viajesData)

  }

  const dialogo = (viaje) => {
    setData(viaje)
    setOpendialog(true)
  }

  const editar = (viaje) => {
    setData(viaje)
    setEditViaje(true)
    setVerEsto(false)
  }

  const handleCloseDialog = () => {
    setOpendialog(!openDialog)
  }

  const borrarViajes = () => {
    fetch(UrlApi + "/viajest1/" + data.idviajes_t1, {
      method: 'DELETE', headers: { 'Content-Type': 'application/json' }
    })
      .then(obtenerViajes, setOpendialog(false))
      .catch(error => {
        console.error('There was an error!', error);
      });
  }


  return (

    <div>
      {veresto &&
        <Container>
          <br></br><br></br><br></br>
          <Grid container spacing={1} direction="row" >
            <Grid item xs={6} md={3}>
              <Typography variant='h4'>{totalkm} Kms</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography variant='h4'>{viajes.length} viajes</Typography>
            </Grid>
          </Grid>
          <br></br>
          <Grid container spacing={1} direction="column" >

            {viajes && viajes.map((viaje, key) =>
              <Grid item >
                <Card key={viaje.idviajes_t1} sx={{ maxWidth: 500, backgroundColor: key % 2 ? "#e4f7e9" : "#edf5ef" }} >
                  <CardHeader
                    avatar={
                      <>
                        <Stack>
                          <Avatar sx={{ bgcolor: "teal" }} aria-label="viaje" variant="rounded">
                            {moment(viaje.fechaviaje).format("DD")}
                          </Avatar>
                          <Avatar sx={{ bgcolor: "black" }} aria-label="viaje" variant="rounded">
                            {moment(viaje.fechaviaje).format("MMM")}
                          </Avatar>
                        </Stack>
                      </>
                    }
                    action={
                      <>
                        <Stack spacing={3}>
                          <IconButton onClick={() => dialogo(viaje)}>
                            <DeleteIcon style={{ color: 'red' }} />
                          </IconButton>
                          <IconButton onClick={() => editar(viaje)}>
                            <CreateIcon style={{ color: 'navy' }} />
                          </IconButton>
                        </Stack>
                      </>
                    }
                    titleTypographyProps={{ variant: 'h5' }}
                    title={`${viaje.desde} -> ${viaje.hasta} `}
                    subheaderTypographyProps={{ variant: 'h6' }}
                    subheader={`${viaje.kmsfinal - viaje.kmsinicio} Kms`}
                  />
                </Card>
              </Grid>
            )}
          </Grid>
          <br></br>
          <br></br>
          <br></br>
        </Container>
      }

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          <Typography variant="h6" align="center">
            {"¿ Confirma que quiere borrar este viaje ?"}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText textAlign={"center"}>
            Se eliminará el viaje {data.desde + "->" + data.hasta} .
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Stack spacing={4} direction="row">
            <Button
              style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
              variant="contained"
              onClick={handleCloseDialog}
            >
              Cancela
            </Button>
            <Button
              style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
              onClick={() => borrarViajes()}
              variant="contained"
            >
              Confirma
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      {editviaje ? <Viajes datos={data} setOpenViajesMostrar={setVerEsto} setOpenViajes={setEditViaje} editar="true" setRefrescar={setRefrescar} /> : null}

    </div >
  )
}
